// 목록 화면 상단의 얇은 메타 스트립(전체 건수 / 설명).
// refine <List>의 헤더를 대체하지 않고, children 최상단에 얹어 쓴다.

import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { SxProps, Theme } from "@mui/material/styles";

export interface ListPageHeaderProps {
  count?: number;
  description?: string;
  sx?: SxProps<Theme>;
  className?: string;
}

export const ListPageHeader: React.FC<ListPageHeaderProps> = ({
  count,
  description,
  sx,
  className,
}) => (
  <Stack
    direction={{ xs: "column", sm: "row" }}
    spacing={{ xs: 0.25, sm: 1 }}
    alignItems={{ xs: "flex-start", sm: "baseline" }}
    className={className}
    sx={{ mb: 2, ...sx }}
  >
    {typeof count === "number" && (
      <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 600 }}>
        전체 {count.toLocaleString()}건
      </Typography>
    )}
    {description && (
      <Typography variant="caption" sx={{ color: "text.disabled" }}>
        {description}
      </Typography>
    )}
  </Stack>
);
